import { PlusOutlined } from "@ant-design/icons";
import {
  ComponentPagination,
  SearchFilter,
  SelectedFilter,
  SharedButton,
  StyledListPage,
  ComponentHeader,
  StyledInnerListPage,
  SharedIconButton,
  PlusIcon,
  DownloadV2,
} from "@components";

import { cdicCouponFilter, PATH_GENERATE_CDIC_COUPON } from "@configs";
import { IFormExportValues } from "@interfaces";
import { CdicCouponTable } from "@modules";
import { selectApp } from "@redux";
import {
  getApiErrorMessage,
  useCdicCouponListPage,
  useExportActiveCdic,
  useExportCdicStatus,
  useNotify,
} from "@utils";
import { Col, Row, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { ExportSidebarCdic } from "./ExportCdic";

export const PageListCdicCoupon = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { success, error } = useNotify();
  const { mobile } = useSelector(selectApp);
  const { id } = useParams<{ id: string }>();
  const exportCdicStatus = useExportCdicStatus();
  const exportActiveCdic = useExportActiveCdic();

  const {
    data,
    total,
    page,
    filters,
    text,
    date,
    refetch,
    handlePagination,
    changeFilter,
    searchText,
    handleClearSearch,
  } = useCdicCouponListPage(id);

  const goToCreate = () => history.push(PATH_GENERATE_CDIC_COUPON);

  const handleDownloadFilter = async (payload: IFormExportValues) => {
    try {
      const { data: fileData } = await exportCdicStatus.mutateAsync({
        id,
        params: {
          active: payload.status?.includes("Active") ? "active" : "",
          expired: payload.status?.includes("Inactive") ? "inactive" : "",
          redeemed: payload.status?.includes("Redeemed") ? "redeemed" : "",
          startDate: payload.date?.[0]
            ? typeof payload.date[0] === "string"
              ? payload.date[0]
              : payload.date[0].format("YYYY-MM-DD")
            : "",
          endDate: payload.date?.[1]
            ? typeof payload.date[1] === "string"
              ? payload.date[1]
              : payload.date[1].format("YYYY-MM-DD")
            : "",
        },
      });
      const url = window.URL.createObjectURL(new Blob([fileData], { type: "text/csv" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export redeem coupon");
      link.click();
      window.URL.revokeObjectURL(url);
      success(t("message.download.success"));
    } catch (err) {
      error(getApiErrorMessage(err, t("message.download.fail")));
    }
  };

  const handleDownload = async () => {
    try {
      const { data: fileData } = await exportActiveCdic.mutateAsync({
        id,
        params: {
          searchColumn: filters,
          search: text,
          startDate: date[0],
          endDate: date[1],
        },
      });
      const url = window.URL.createObjectURL(new Blob([fileData], { type: "text/csv" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export redeem coupon");
      link.click();
      window.URL.revokeObjectURL(url);
      success(t("message.download.success"));
    } catch (err) {
      error(getApiErrorMessage(err, t("message.download.fail")));
    }
  };

  const button = (
    <>
      {mobile ? (
        <Tooltip title={t("page.add_new_coupon_family")}>
          <SharedIconButton type="primary" ghost icon={<PlusIcon />} onClick={goToCreate} />
        </Tooltip>
      ) : (
        <Row gutter={8}>
          <Col>
            <Tooltip title={t("page.export_data_by_filter")}>
              <ExportSidebarCdic
                data={data}
                handleExport={(params: IFormExportValues) => handleDownloadFilter(params)}
              />
            </Tooltip>
          </Col>
          <Col>
            <Tooltip title={t("page.download_excel")}>
              <SharedButton
                type="primary"
                icon={<DownloadV2 />}
                size="middle"
                onClick={handleDownload}
                style={{ background: "#00AA67", color: "#fff" }}
              >
                {t("page.download_coupons")}
              </SharedButton>
            </Tooltip>
          </Col>
          <Col>
            <Tooltip title={t("page.add_cf")}>
              <SharedButton
                type="primary"
                ghost
                icon={<PlusOutlined />}
                size="middle"
                onClick={goToCreate}
              >
                {t("page.add_cf")}
              </SharedButton>
            </Tooltip>
          </Col>
        </Row>
      )}
    </>
  );

  return (
    <>
      <ComponentHeader title={t("page.cdic_coupon_management")} />
      <StyledListPage>
        <StyledInnerListPage>
          <SearchFilter
            actionBtn={button}
            filter={cdicCouponFilter}
            callbackFun={changeFilter}
            searchText={searchText}
            searchInputPlaceholder={t("page.search_user_by")}
            selectedOption={filters}
          />
          <SelectedFilter
            handleClearSearch={handleClearSearch}
            selected={filters}
            formDate={date[0]}
            toDate={date[1]}
          />
          <CdicCouponTable data={data} callback={refetch} />
          <ComponentPagination total={total} page={page.page} changePage={handlePagination} />
        </StyledInnerListPage>
      </StyledListPage>
    </>
  );
};
